export function formatNumber(value: number) {
  return value.toFixed(2).replace(/[.,](00)|0$/, "");
}
